const Hamburger = () => {
    return(
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="50"
            viewBox="0 0 30 30"
        >
            <path d="M26,8c0,1.104-0.896,2-2,2H8c-1.104,0-2-0.896-2-2s0.896-2,2-2h16C25.104,6,26,6.896,26,8z"/>
            <path d="M26,16c0,1.104-0.896,2-2,2H8c-1.104,0-2-0.896-2-2s0.896-2,2-2h16C25.104,14,26,14.896,26,16z"/>
            <path d="M26,24c0,1.104-0.896,2-2,2H8c-1.104,0-2-0.896-2-2s0.896-2,2-2h16C25.104,22,26,22.896,26,24z"/>
            <title>
                Open navigation menu.
            </title>
        </svg>
    )
}

export default Hamburger;